import countryCodes from 'country-codes-list';
import { BLACK_LISTED_COUNTRIES, PRIORITY_COUNTRIES } from '../constants';

let allCountryCodes: countryCodes.CountryData[];

export function getAllCountryCodes(): countryCodes.CountryData[] {
    if (allCountryCodes && allCountryCodes?.length > 0) {
        return allCountryCodes;
    }

    const countryCodeData = countryCodes
        .all()
        .filter((c) => !BLACK_LISTED_COUNTRIES.has(c['countryCode']));

    const nonPriorityCountries = countryCodeData.filter(
        (c) => !PRIORITY_COUNTRIES.includes(c['countryCode']),
    );

    const priorityCountries = PRIORITY_COUNTRIES.map((c) =>
        countryCodeData.find((country) => country['countryCode'] === c),
    ).filter(Boolean);

    allCountryCodes = [
        ...(priorityCountries as countryCodes.CountryData[]),
        ...nonPriorityCountries,
    ];

    return allCountryCodes;
}
